//
// Copyright (c) 2011-2020 by Curalate, Inc.
//

import React from 'react';
import styled from 'styled-components';

import { IContentLibraryItem } from '@apis/content-library/contentLibraryApiModel';
import HorizontalScrolling, {
  ARROW_WIDTH_LARGE,
  ARROW_WIDTH_SMALL,
} from '@components/organisms/horizontal-scrolling/HorizontalScrolling';
import StreamsDrawerGridCarouselCard from '@streams-drawer/streams-drawer-content/streams-drawer-moderation-content/StreamsDrawerGridCarouselCard';

const SMALL_IMAGE_SIZE = 220;
const LARGE_IMAGE_SIZE = 300;

interface Props {
  items: IContentLibraryItem[];
  imageSize: 'large' | 'small';
}

const StreamsDrawerCarousel = ({ imageSize, items }: Props) => {
  const imageWidth =
    imageSize === 'large' ? LARGE_IMAGE_SIZE : SMALL_IMAGE_SIZE;

  const scrollDistance = imageWidth + 15 + 1;

  const carouselItems = items.map((item) => {
    return (
      <StreamsDrawerGridCarouselCard
        key={item.id}
        disableBulkActions={false}
        item={item}
        width={imageWidth}
      />
    );
  });

  const horizontalScrollingArrowWidth =
    imageSize === 'small' ? ARROW_WIDTH_SMALL : ARROW_WIDTH_LARGE;

  return (
    <HorizontalScrolling
      alwaysShowArrows={true}
      childSize={imageSize}
      resetScrollDep={items}
      scrollDistance={(distanceContentShiftedLeft) => {
        return distanceContentShiftedLeft === 0
          ? scrollDistance - horizontalScrollingArrowWidth
          : scrollDistance;
      }}
    >
      <CarouselContainer>{carouselItems}</CarouselContainer>
    </HorizontalScrolling>
  );
};

const CarouselContainer = styled.div`
  width: 100%;
  display: flex;
  flex-wrap: nowrap;
  padding: 16px;
  & > * {
    :not(:first-of-type) {
      margin-left: 16px;
    }
  }
`;

export default StreamsDrawerCarousel;
